// SPDX-License-Identifier: AGPL-3.0-or-later

export const PRODUCT_NAME = 'Raven';
export const DEFAULT_PREMIUM_PRODUCT_NAME = 'Premium';
